// extracted by mini-css-extract-plugin
module.exports = {"onboarding-screen":"onboarding_onboarding-screen__4ERgh"};